<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "Line Profile Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current line Profile config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'Line Profile Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="isShowAddTable = true"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                 <div
                      @click="clkEditLine()"
                      class="btn"
                      :class="{ disabled: false }"
                      style="padding: 0px"
                    >
                      <i class="fa fa-edit page-tableaction"></i>
                    </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th v-for="(value, key) in title" :key="key" :title="value">
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in linePriTable"
                :key="row.profileid"
                :class="{ 'true:': true }"
                @click="changeSelect(row)"
              >
                <td width="40px">
                  <div @click.stop="" v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + index"
                    />
                    <label :for="'idRowSelect' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.profileId }}</div>
                </td>
                <td>
                  <div>{{ row.profileName }}</div>
                </td>
                <td>
                  <div>{{ row.deviceType }}</div>
                </td>
                <td>
                  <div>{{ row.mapMode | formatmap }}</div>
                </td>
                <td>
                  <div>{{ row.trafficMode | formmatTraffic }}</div>
                </td>
                <td>
                  <div>{{ row.alarmRefId }}</div>
                </td>
                <td>
                  <div>{{ row.mcastRefId }}</div>
                </td>
                <td>
                  <div
                    @click="clkEdit(row.profileId, row.mapMode)"
                    class="btn"
                    :class="{ disabled: false }"
                    style="padding: 0px"
                  >
                    <i class="fa fa-external-link page-tableaction"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'Line Profile Edit'"
              @close="clkCancel()"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="profileId">{{
                    title.profileId
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(1)}">
                    <input
                      type="text"
                      class="form-control"
                      id="profileId"
                      :disabled="isEditClik"
                      v-model="linePriForm.profileId"
                      autocomplete="off"
                      :placeholder=" 'INTEGER<0-' + profileMaxNum + '>'"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(1) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(1) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="name">{{
                    title.profileName
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(2)}">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      maxlength="128"
                      v-model="linePriForm.profileName"
                      autocomplete="off"
                      placeholder="STRING<1-128>"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(2) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(2) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="devicetype">{{
                    title.deviceType
                  }}</label>
                  <div class="col-sm-5">
                    <select
                      class="form-control"
                      id="devicetype"
                      :disabled="isEditClik"
                      v-model="linePriForm.deviceType"
                    >
                      <option value="" disabled selected style="display: none">
                        please choose..
                      </option>
                      <option
                        v-for="(row, index) in devTypeAll"
                        :key="index"
                        :value="row.type"
                      >
                        {{ row.type + "(" + row.desc + ")"}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="mappingmode">{{
                    title.mapMode
                  }}</label>
                  <div class="col-sm-5">
                    <select
                      class="form-control"
                      :disabled="isEditClik"
                      id="mappingmode"
                      v-model="linePriForm.mapMode"
                    >
                      <option value="" disabled selected style="display: none">
                        please choose..
                      </option>
                      <option value="0">VLAN</option>
                      <option value="1">Priority</option>
                      <option value="2">VLAN+Priority</option>
                      <option value="3">Port</option>
                      <option value="4">Port+VLAN</option>
                      <option value="5">Port+Priority</option>
                      <option value="6">Port+VLAN+Priority</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="trafficmode">{{
                    title.trafficMode
                  }}</label>
                  <div class="col-sm-5">
                    <select
                      class="form-control"
                      id="trafficmode"
                      :disabled="isEditClik"
                      v-model="linePriForm.trafficMode"
                    >
                      <option value="" disabled selected style="display: none">
                        please choose..
                      </option>
                      <option value="0">Pri Queue</option>
                      <option value="1">Car</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="alarm">{{
                    title.alarmRefId
                  }}</label>
                  <div class="col-sm-5">
                    <select
                      class="form-control"
                      id="alarm"
                      v-model="linePriForm.alarmRefId"
                    >
                      <option value="">
                        None
                      </option>
                      <option v-for="alarm in alarmProfileTable.data" :key="alarm.profileid" :value="alarm.profileid" >{{alarm.profileid + ":"+ alarm.name}}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="mcast">{{
                    title.mcastRefId
                  }}</label>
                  <div class="col-sm-5">
                      <select
                      class="form-control"
                      id="mcast"
                      v-model="linePriForm.mcastRefId"
                    >
                      <option value="">
                        None
                      </option>
                      <option v-for="mcast in multicastProfileTable.data" :key="mcast.profileid" :value="mcast.profileid" >{{mcast.profileid + ":" + mcast.name }}</option>
                    </select>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>


<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "profileLinePri",
  components: {
    BlockCntr,
    DialogBox,
    InfoBox,
  },

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      select: [],
      devTypeAll: [],
      linePriForm: {
        profileId: "",
        profileName: "",
        deviceType: "",
        mapMode: "0",
        trafficMode: "0",
        alarmRefId: "",
        mcastRefId: "",
      },

      linePriTable: [],
      multicastProfileTable:"",
      alarmProfileTable:"",
      profileMaxNum: "2047",
    }
  },

  created() {
    this.loadontDevInfo()
    this.loadLineProfilePri()
    this.loadMulticastProfile()
    this.loadAlarmProfile()
    this.loadProfileNum()
  },

  methods: {
    loadLineProfilePri() {
      get("profilelinepri")
        .then((res) => {
          this.title = res.data.title
          this.linePriTable = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadMulticastProfile() {
      get("multicastProfile")
        .then((res) => (this.multicastProfileTable = res.data))
        .catch((err) => {
          console.log(err)
        })
    },

    loadAlarmProfile() {
      get("alarmProfile")
        .then((res) => (this.alarmProfileTable = res.data))
        .catch((err) => {
          console.log(err)
        })
    },


    loadontDevInfo() {
      get("profileontdev")
        .then((res) => {
          this.devTypeAll = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadProfileNum() {
      get("profilemaxnum")
        .then((res) => {
          this.profileMaxNum = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var linePriFormTmp = {
        profileId: "",
        profileName: "",
        deviceType: "",
        mapMode: "0",
        trafficMode: "0",
        alarmRefId: "",
        mcastRefId: "",
      }

      this.linePriForm = linePriFormTmp
    },

    profileSortFun(a, b) {
      return Number(a.profileId) - Number(b.profileId)
    },

    clkApply() {
      var newProfile = {
        profileId: Number(this.linePriForm.profileId),
        profileName: this.linePriForm.profileName,
        deviceType: this.linePriForm.deviceType,
        mapMode: Number(this.linePriForm.mapMode),
        trafficMode: Number(this.linePriForm.trafficMode),
        alarmRefId: Number(this.linePriForm.alarmRefId),
        mcastRefId: Number(this.linePriForm.mcastRefId),
        operate: 1,
      }

      if(this.linePriForm.profileId == "")
      {
        this.showAlertBox(
              "warn",
              "Message",
              "Invalid profileID"
          )
         return 
      }

      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      if (this.linePriForm.alarmRefId == "") newProfile.alarmRefId = -1
      if (this.linePriForm.mcastRefId == "") newProfile.mcastRefId = -1

      if (!this.isEditClik) {
        for (let i = 0; i < this.linePriTable.length; i++) {
          if (this.linePriTable[i].profileId == newProfile.profileId) {
            this.showAlertBox(
              "warn",
              "Message",
              "this profile id has been existed,please choose a new one"
            )
            return
          }
        }
      }
      else
      {
        newProfile.operate = 3;
      }

      post("profilelinepri", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadLineProfilePri()
            /*if (newProfile.alarmRefId == -1) newProfile.alarmRefId = ""
            if (newProfile.mcastRefId == -1) newProfile.mcastRefId = ""
            if (this.isEditClik) {
              let index = this.select[0]
              this.linePriTable[index] = newProfile
            } else {
              this.linePriTable.push(newProfile)
              this.linePriTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit(value, mode) {
      this.$router.push({
        path: "profilelinestep/" + value,
        query: { mapmode: mode},
      }


      )
    },
    clkEditLine() {
      for (let i = 0; i < this.linePriTable.length; i++) {
        if (this.linePriTable[i].selected) {
          this.linePriForm.profileId = this.linePriTable[i].profileId
          if(this.linePriTable[i].profileName.match(/^INDEX_/) == null)
          {
            this.linePriForm.profileName = this.linePriTable[i].profileName
          }
          this.linePriForm.deviceType = this.linePriTable[i].deviceType
          this.linePriForm.mapMode = this.linePriTable[i].mapMode
          this.linePriForm.trafficMode = this.linePriTable[i].trafficMode
          this.linePriForm.alarmRefId = this.linePriTable[i].alarmRefId
           this.linePriForm.mcastRefId = this.linePriTable[i].mcastRefId
       
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: 0,
        operate: 2,
      }

      for (i = 0; i < this.linePriTable.length; i++) {
        if (this.linePriTable[i].selected) {
          newProfile.profileId = Number(this.linePriTable[i].profileId)
          del.push(post("profilelinepri", newProfile))
          id.push(this.linePriTable[i].profileId)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.linePriTable.length; i++) {
                if (this.linePriTable[i].profileId == id[index]) {
                  this.linePriTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.linePriTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.linePriTable[i], "selected", true)
        } else {
          this.$set(this.linePriTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    input_para_check(value)
    {
      if(value == 1 || value == 0)
      {
        if(this.linePriForm.profileId != "")
        {
            let profileid = Number(this.linePriForm.profileId)

            if(!isNaN(profileid))
            {
                if(profileid < 0 || profileid > Number(this.profileMaxNum))
                return "profile id must be in range 0-"+ this.profileMaxNum
            }
            else
              return "profile id must be in range 0-"+ this.profileMaxNum
        }
      }
      
      if(value == 2 || value == 0)
      {
        var space=/[\s]/
        if (space.test(this.linePriForm.profileName)) return "Contains illegal characters."
        else
        return nonASCIIchar(this.linePriForm.profileName)
      }
      return null
    }
  },

  filters: {
    formatmap: function (value) {
      if (value == "0") return "VLAN"
      else if (value == "1") return "Priority"
      else if (value == "2") return "VLAN+Priority"
      else if (value == "3") return "Port"
      else if (value == "4") return "Port+VLAN"
      else if (value == "5") return "Port+Priority"
      else if (value == "6") return "Port+VLAN+Priority"
      else return value
    },

    formmatTraffic: function (value) {
      if (value == "0") return "Pri Queue"
      else if (value == "1") return "Car"
      else return value
    },
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>